import { render } from "./AddCardPage.vue?vue&type=template&id=4f0c218a&scoped=true"
import script from "./AddCardPage.vue?vue&type=script&lang=js"
export * from "./AddCardPage.vue?vue&type=script&lang=js"

import "./AddCardPage.vue?vue&type=style&index=0&id=4f0c218a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0c218a"]])

export default __exports__